/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1449
 */

var r = require(/* 451 */"../../../../../../2467/451")
var i = require(/* 1180 */"../../../../2533/1180")
var o = require(/* 2525 */"./2525/index")
var a = require(/* 2528 */"./2528/index")
module.exports = function (e, t) {
  return r(e) ? e : i(e, t) ? [e] : o(a(e))
}
